import VuexPersist from 'vuex-persist'

const sessionPersist = new VuexPersist({
    key: 'sopra.session',
    storage: window.localStorage,
    modules: ["session"],
})
  

export default [
    sessionPersist.plugin
]
